import { render, staticRenderFns } from "./BasicToDoDetails.vue?vue&type=template&id=edeab4ac"
import script from "./BasicToDoDetails.vue?vue&type=script&lang=js"
export * from "./BasicToDoDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports